const actions = {
    SIM_SWAP: "SIM_SWAP",
    SIM_SWAP_SUCCESS: "SIM_SWAP_SUCCESS",
    SIM_SWAP_FAILED: "SIM_SWAP_FAILED",
    RESET_MESSAGE: "RESET_MESSAGE",

    MDN_SWAP: "MDN_SWAP",
    MDN_SWAP_SUCCESS: "MDN_SWAP_SUCCESS",
    MDN_SWAP_FAILED: "MDN_SWAP_FAILED",

    simswap: (data) => ({
        type: actions.SIM_SWAP,
        payload: (data),
    }),
    simSwapSuccess: (message) => ({
        type: actions.SIM_SWAP_SUCCESS,
        message,
    }),
    simSwapError: (error, fResult) => ({
        type: actions.SIM_SWAP_FAILED,
        payload: { error, fResult },
    }),

    mdnswap: (data) => ({
        type: actions.MDN_SWAP,
        payload: (data),
    }),
    mdnswapSuccess: (message) => ({
        type: actions.MDN_SWAP_SUCCESS,
        message,
    }),
    mdnswapError: (error, fResult) => ({
        type: actions.MDN_SWAP_FAILED,
        payload: { error, fResult },
    }),
    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),

}
export default actions;